import React from 'react';
import DocumentTemplateSettings from '../components/documents/DocumentTemplateSettings';

export default function InvoiceSettings() {
  return (
    <DocumentTemplateSettings
      title="Invoice & Proforma Templates"
      description="Configure tax invoice and proforma presentation profiles on the unified document architecture. Finalized documents keep their immutable snapshots even if the profile changes later."
      documentTypes={[
        { value: 'TAX_INVOICE', label: 'Invoice' },
        { value: 'PROFORMA_INVOICE', label: 'Proforma Invoice' },
      ]}
    />
  );
}
